export default "__VITE_ASSET__d26e91ce__"